import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const licenseAccessModuleEnableResultSlice = getBulkActionSlice(
    'licenseAccessModuleEnableResult',
);

export const selectLicenseAccessModuleEnableResultShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.licenseAccessModuleEnableResult.shown;

export const selectLicenseAccessModuleEnableResultTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.licenseAccessModuleEnableResult.backgroundTask;

export const selectLicenseAccessModuleEnableResultUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.licenseAccessModuleEnableResult.uuid;

export const {
    setShown,
    setBackgroundTask,
    clearResult,
    setUuid,
} = licenseAccessModuleEnableResultSlice.actions;
